export default {
  regions: [],
  provinces: [],
  cities: [],
  barangays: [],
};
